<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Edycja komornika</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'bailiffs-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button :class="{isLoading : submitting}" theme="success" @click.prevent="submitForm"><i class="material-icons">add</i> Zapisz zmiany</d-button>
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">
                <d-card-header>
                    <h6 class="m-0">Dane komornika</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>

                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.name" name="name" label="Imię i nazwisko" placeholder="Imię i nazwisko"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="phone_number">Telefon</label>
                                    <d-input id="phone_number"
                                             type="text"
                                             name="phone_number"
                                             maxlength="9"
                                             @input="lar_errors.clear('phone_number')"
                                             :class="{'is-invalid' : lar_errors.has('phone_number')}"
                                             v-model="bailiff.phone_number"
                                             placeholder="Nr telefonu" />
                                    <div class="invalid-feedback" v-text="lar_errors.get('phone_number')"></div>
                                    <d-button theme="primary" class="mt-2" @click.prevent="telephonesModal = true"><i class="fa fa-phone mr-1"></i> Dodatkowe numery ({{bailiff.telephones.length}})</d-button>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.email" name="email" label="Adres e-mail" placeholder="Adres e-mail"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.court_name" name="court_name" label="Nazwa sądu" placeholder="Nazwa sądu"></ss-input>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
                <d-card-header>
                    <h6 class="m-0">Adres kancelarii komorniczej</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_name" name="bailiff_office_name" label="Nazwa kancelarii" placeholder="Nazwa kancelarii"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_address" name="bailiff_office_address" label="Ulica i numer" placeholder="Ulica i numer"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_house_number" name="bailiff_office_house_number" label="Numer mieszkania" placeholder="Nazwa kancelarii"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_flat_number" name="bailiff_office_flat_number" label="Numer lokalu" placeholder="Numer lokalu"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="bailiff_postcode">Kod pocztowy</label>
                                    <d-input id="bailiff_postcode"
                                             type="text"
                                             name="invoice_postcode"
                                             v-mask="'##-###'"
                                             v-model="bailiff.bailiff_office_post_code"
                                             @input="lar_errors.clear('bailiff_office_post_code')"
                                             :class="{'is-invalid' : lar_errors.has('bailiff_office_post_code')}"
                                             placeholder="00-000" />
                                    <div class="invalid-feedback" v-text="lar_errors.get('bailiff_office_post_code')"></div>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_city" name="bailiff_office_city" label="Miasto" placeholder="Miasto"></ss-input>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
                <template v-if="bailiff.id">
                    <d-card-header>
                        <h6 class="m-0">Sprawy</h6>
                    </d-card-header>
                    <d-list-group class="p-3" flush>
                        <table class="table mb-0 responsive-table text-center">
                            <thead class="bg-light">
                            <tr>
                                <th scope="col" class="border-0">Sygnatura sprawy</th>
                                <th scope="col" class="border-0">Osoba egzekwowana</th>
                                <th scope="col" class="border-0">Weryfikacja</th>
                                <th scope="col" class="border-0">Pozyskano</th>
                                <th scope="col" class="border-0">Status sprawy</th>
                                <th scope="col" class="border-0">Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(execution, index) in bailiff.cases" :key="index">
                                    <td>
                                        <dt>Sygnatura sprawy</dt>
                                        <dd>{{ execution.number }}</dd>
                                    </td>
                                    <td class="text-left">
                                        <dt>Osoba egzekwowana</dt>
                                        <dd v-html="executionPerson(execution)"></dd>
                                    </td>
                                    <td>
                                        <dt>Weryfikacja</dt>
                                        <dd v-if="execution.applications && execution.applications.length > 0">
                                            <span :id="'execution-' + execution.id" :class="{'text-success' : allApplicationsCompleted(execution)}">{{ completeApplications(execution.applications) }}/{{ execution.applications.length }}</span>
                                            <d-popover :target="'execution-' + execution.id"
                                                       :triggers="['hover']"
                                                       theme="black"
                                                       container=".shards-demo--example--tooltip-02">
                                                <div class="d-flex justify-content-between mt-1 mb-1" v-for="application in execution.applications">
                                                    <span>{{ application.application_name ? application.application_name : 'Brak nazwy' }}</span><i class="fa fa-check ml-3 text-success" v-if="application.status.toString() === '1'"></i>
                                                </div>
                                            </d-popover>
                                        </dd>
                                        <dd v-else class="text-success">0/0</dd>
                                    </td>
                                    <td>
                                        <dt>Pozyskano</dt>
                                        <dd>{{ execution.contributions_sum }} zł</dd>
                                    </td>
                                    <td>
                                        <dt>Status sprawy</dt>
                                        <dd>
                                            <span v-if="execution.applications && allApplicationsCompleted(execution)" class="text-success">Zakończona</span>
                                            <span v-else>W trakcie</span>
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Akcje</dt>
                                        <dd class="wsnw">
                                            <d-button
                                                @click.prevent="editExecution(execution)"
                                                :disabled="actionInProgress"
                                                class="mr-1 mr-3">
                                                <i class="material-icons">edit</i> Edytuj
                                            </d-button>
                                            <d-button
                                                @click.prevent="removeExecution(execution)"
                                                theme="danger"
                                                :disabled="actionInProgress"
                                                class="mr-1 mr-3">
                                                <i class="material-icons">delete</i> Usuń
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </d-list-group>
                </template>

                <ss-modal
                        v-show="telephonesModal"
                        title="Telephone"
                        intro="bounceIn"
                        outro ="bounceOut">
                    <!-- HEADER -->
                    <div slot = "modal-header" style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
                        <span>Numery telefonów</span>
                        <d-button theme="success" @click.prevent="addTelephone"><i class="material-icons">add</i>Dodaj</d-button>
                    </div>
                    <!-- BODY -->
                    <div slot = "modal-body">
                        <table class="table">
                            <thead>
                                <tr>
                                    <td>Numer telefonu</td>
                                    <td>Opis</td>
                                    <td>Akcje</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(telephone, index) in bailiff.telephones" :key="index">
                                    <td>
                                        <ss-input type="number" v-model="telephone.phone_number" maxlength="9" name="phone_number" />
                                    </td>
                                    <td>
                                        <ss-textarea v-model="telephone.description" name="description"></ss-textarea>
                                    </td>
                                    <td>
                                        <d-button @click.prevent="removeTelephone(index)" theme="danger" class="mr-1 mr-3"><i class="material-icons">delete</i> Usuń</d-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- FOOTER -->
                    <div slot = "modal-footer">
                        <d-button @click.prevent="telephonesModal = false" theme="danger">Zamknij</d-button>
                    </div>
                </ss-modal>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
  import LarErrors from '../helpers/Errors';
  import BailiffUtil from '../utils/bailiff';
  import SsModal from '../components/common/SsModal';

  export default {
    name: "BailiffEdit",
    components: {
      LarErrors,
      SsModal
    },
    data(){
      return{
        fetched: false,
        lar_errors: LarErrors,
        submitting: false,
        bailiff: _.clone(BailiffUtil),
        telephonesModal: false,
        actionInProgress: false
      }
    },
    methods: {
      fetchData(){
        this.fetched = false;
        axios.post('api/bailiff/get-bailiff/' + this.$route.params.id).then(response => {
          this.bailiff = response.data.data;
          this.fetched = true;
        }).catch(errors => {
          console.log(errors);
          this.fetched = true;
        })
      },
      editExecution(execution) {
        this.$router.push({name: 'contract-edit', params: { client_id: execution.client_id, schedule_id: execution.schedule_id, case_id: execution.id }})
      },
      removeExecution(execution) {
        this.actionInProgress = true;

        Vue.swal({
            title: 'Uwaga',
            html: 'Czy potwierdzasz usunięcie sprawy?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            buttonsStyling: true
        }).then((logout) => {
            if(logout.value){
                axios.post('api/contracts-case/remove-case/' + execution.id).then(response => {
                Vue.swal({
                    type: 'success',
                    title: 'Sprawa została usunięta.',
                    showConfirmButton: true,
                }).then(() => {
                    this.actionInProgress = false;
                    this.fetchData()
                })
                }).catch((errors) =>{
                    this.actionInProgress = false;
                    console.log(errors);
                })
            }
        }).catch((errors) =>{
            console.log(errors);
            this.actionInProgress = false;
        })
      },
      executionPerson(execution) {
        let person = '';
        if (execution.guarantor_id) {
          person = `<span class="text-light">Poręczyciel</span><br />
            ${execution.guarantor_name} ${execution.guarantor_last_name}`;
        } else if (execution.client_type === 'corporation') {
          person = `<span class="text-light">Pożyczkobiorca</span><br />
            ${execution.company_name}`;
        } else {
          person = `<span class="text-light">Pożyczkobiorca</span><br />
            ${execution.client_name} ${execution.client_last_name}`;
        }
        return person
      },
      addTelephone() {
        if (this.bailiff.telephones.length === 0 || this.bailiff.telephones[this.bailiff.telephones.length -1].phone_number) {
          this.bailiff.telephones.push({
            phone_number: '',
            description: ''
          })
        }
      },
      removeTelephone(index) {
        this.bailiff.telephones.splice(index, 1);
        this.$forceUpdate();
      },
      completeApplications(applications) {
        const reducedApplications = applications.reduce((accumulator, application) => {
          if (application.status.toString() === '1') {
            return accumulator + 1
          }
          return accumulator
        }, 0);
        return reducedApplications
      },
      allApplicationsCompleted({applications}){
        return this.completeApplications(applications) === applications.length
      },
      submitForm(){
        this.submitting = true;
        if (this.bailiff.telephones.length > 0 && !this.bailiff.telephones[this.bailiff.telephones.length -1].phone_number) {
          this.bailiff.telephones.splice(this.bailiff.telephones.length - 1)
        }
        axios.post('api/bailiff/update-bailiff/' + this.$route.params.id, this.bailiff).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Komornik został zapisany.',
            showConfirmButton: true,
          }).then(() => {
            this.$router.push({name: 'bailiffs-list'});
          });
          this.submitting = false;
        }).catch((error) =>{

          this.submitting = false;
          console.log(error);
          LarErrors.record(error.response.data.errors)
        })
      },
    },
    mounted(){
      this.fetchData()
    }
  }
</script>
